{
  "CSServiceForms": {
    "retrieveFeedback": {
      "page": {
        "refundCaseNotSupportedNotification": "Syötit lomakkeelle takaisinmaksuhakemuksen numeron. Voit hakea tapauksesi <a data-contentid=\"2665220\" href=\"/fi-fi/asiakaspalvelu-ja-yhteystiedot/yhteydenottolomakkeet/takaisinmaksun-tila\">Takaisinmaksun tila -lomakkeella</a>."
      }
    }
  },
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "iataNumber": {
          "pattern": "IATA-numero voi sisältää vain 7 tai 8 merkkiä."
        }
      }
    }
  }
}
